import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/KebunL.css";
import Swal from "sweetalert2";
import axios from "axios";

const KebunL = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [logisticsData, setLogisticsData] = useState([]);
  const [rencanaPanenId, setRencanaPanenId] = useState("");
  const [error, setError] = useState("");
  const [selectedLogistik, setSelectedLogistik] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    // Fetch Daftar Vendor Logistik
    axios
      .get("https://c-greenproject.org:7500/daftar_logistik", {
        withCredentials: true,
      })
      .then((response) => {
        setLogisticsData(response.data || []);
      })
      .catch((error) => {
        console.error("Error fetching logistics:", error);
      });

    // Fetch User Role
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      Swal.fire("Gagal", "Gagal logout. Silakan coba lagi.", "error");
    }
  };

  const handlePilih = (logistikId) => {
    setSelectedLogistik(logistikId);
    setRencanaPanenId("");
    setError("");
    setShowModal(true);
  };

  const handleSubmitRencanaPanen = async () => {
    if (!rencanaPanenId) {
      setError("ID Rencana Panen wajib diisi!");
      return;
    }

    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/pilih_logistik",
        {
          rencana_panen_id: rencanaPanenId,
          logistik_id: selectedLogistik,
        },
        { withCredentials: true }
      );

      Swal.fire({
        icon: "success",
        title: "Pengiriman Berhasil Diproses!",
        html: `Tracking ID Anda: <br><strong class="font-monospace fs-5 text-success">${response.data.tracking_id}</strong>`,
        confirmButtonColor: "#198754",
      });

      setShowModal(false);

      const resUpdated = await axios.get("https://c-greenproject.org:7500/daftar_logistik", {
        withCredentials: true,
      });
      setLogisticsData(resUpdated.data || []);
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Terjadi kesalahan koneksi";
      setError(errorMsg);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#f8fafc" }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center px-4 py-2 bg-white border-bottom shadow-sm">
        <img src="/static/logo_potrait.png" alt="Logo" style={{ height: "38px" }} />
        <div className="d-flex align-items-center gap-3">
          <span className="fw-semibold text-secondary small">
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 py-1"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="p-3 bg-white border-end shadow-sm" style={{ width: "240px", flexShrink: 0 }}>
          <p className="text-muted small mb-1">Portal Traceability</p>
          <h6 className="fw-bold mb-2 text-dark">Telsa Super Apps</h6>
          <p className="text-muted small d-flex align-items-center gap-2 mb-4" style={{ fontSize: "12px" }}>
            <img src="/static/schedule_11145854.png" alt="Date" width="14" />
            {tanggal}
          </p>

          <div className="d-flex flex-column gap-1">
            <div
              onClick={() => navigate("/kebun")}
              className={`p-2 rounded-3 d-flex align-items-center gap-2 ${
                location.pathname === "/kebun" ? "bg-success text-white fw-bold" : "text-dark"
              }`}
              style={{ cursor: "pointer", fontSize: "14px" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" width="18" /> Beranda
            </div>
            <div
              onClick={() => navigate("/KebunP")}
              className={`p-2 rounded-3 d-flex align-items-center gap-2 ${
                location.pathname.toLowerCase().includes("kebunp") &&
                !location.pathname.toLowerCase().includes("kebunpabrik")
                  ? "bg-success text-white fw-bold"
                  : "text-dark"
              }`}
              style={{ cursor: "pointer", fontSize: "14px" }}
            >
              <img src="/static/Tanam.png" alt="Planting" width="18" /> Petani
            </div>
            <div
              onClick={() => navigate("/kebunL")}
              className={`p-2 rounded-3 d-flex align-items-center gap-2 ${
                location.pathname.toLowerCase().includes("kebunl")
                  ? "bg-success text-white fw-bold"
                  : "text-dark"
              }`}
              style={{ cursor: "pointer", fontSize: "14px" }}
            >
              <img src="/static/shipping.png" alt="Logistics" width="18" /> Logistik
            </div>
            <div
              onClick={() => navigate("/kebunpabrik")}
              className={`p-2 rounded-3 d-flex align-items-center gap-2 ${
                location.pathname === "/kebunpabrik" ? "bg-success text-white fw-bold" : "text-dark"
              }`}
              style={{ cursor: "pointer", fontSize: "14px" }}
            >
              <img src="/static/factory.png" alt="Factory" width="18" /> Pabrik
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div
          className="flex-grow-1 p-4"
          style={{
            width: "calc(100% - 240px)",
            minWidth: 0,
            overflowX: "hidden",
          }}
        >
          {/* Header Title & Button */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold text-dark mb-1">Manajemen Logistik</h2>
              <p className="text-secondary small mb-0">
                Pilih vendor logistik dengan armada dan kapasitas angkut yang tersedia untuk penjemputan sawit.
              </p>
            </div>
            <button
              className="btn btn-success rounded-pill px-4 shadow-sm fw-medium"
              onClick={() => navigate("/kebunL/pengajuan")}
            >
              + Pengajuan Logistik
            </button>
          </div>

          {/* Table Container Card (Full Width) */}
          <div
            className="bg-white rounded-4 shadow-sm border p-4"
            style={{ width: "100%", minWidth: 0 }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 className="fw-bold text-success mb-0">Daftar Vendor Tersedia</h5>
                <span className="text-muted small">Total {logisticsData.length} vendor terdaftar</span>
              </div>
            </div>

            {logisticsData && logisticsData.length > 0 ? (
              <div className="table-responsive w-100" style={{ width: "100%" }}>
                <table className="table table-hover align-middle mb-0 w-100" style={{ minWidth: "1100px" }}>
                  <thead className="table-light">
                    <tr className="text-secondary small fw-semibold">
                      <th className="text-center py-3" style={{ width: "60px" }}>No</th>
                      <th className="py-3">Nama Perusahaan</th>
                      <th className="py-3 text-center" style={{ width: "200px" }}>Kontak (No. HP)</th>
                      <th className="text-center py-3" style={{ width: "220px" }}>Armada Tersedia</th>
                      <th className="py-3" style={{ width: "220px" }}>Kapasitas Angkut Tersisa</th>
                      <th className="text-center py-3" style={{ width: "220px" }}>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logisticsData.map((item, index) => {
                      const totalTruk = item.total_truk ?? item.jumlah_truk ?? 0;
                      const trukTersedia = item.truk_tersedia ?? (item.is_ready ? totalTruk : 0);
                      const kapasitasTersedia = Number(item.kapasitas_tersedia ?? item.kapasitas_total ?? 0);
                      const kapasitasTotal = Number(item.kapasitas_total ?? 0);
                      const isReady = item.is_ready !== undefined ? item.is_ready : trukTersedia > 0;

                      return (
                        <tr key={`logistik-${item.logistik_id || index}`}>
                          <td className="text-center text-muted small fw-medium">
                            {index + 1}
                          </td>
                          <td>
                            <span className="fw-bold text-dark d-block">{item.nama || "-"}</span>
                            <span className="text-muted" style={{ fontSize: "11px" }}>Vendor Logistik Terverifikasi</span>
                          </td>
                          <td className="text-center font-monospace text-secondary small">
                            📞 {item.nomor_hp || "-"}
                          </td>

                          {/* Kolom Armada Truk */}
                          <td className="text-center">
                            {totalTruk === 0 ? (
                              <span className="badge bg-secondary-subtle text-secondary px-3 py-2 rounded-pill font-monospace" style={{ fontSize: "11px" }}>
                                Belum ada armada
                              </span>
                            ) : trukTersedia === 0 ? (
                              <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-2 rounded-pill fw-semibold font-monospace" style={{ fontSize: "11px" }}>
                                0 / {totalTruk} Unit (Penuh)
                              </span>
                            ) : (
                              <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2 rounded-pill fw-semibold font-monospace" style={{ fontSize: "11px" }}>
                                {trukTersedia} / {totalTruk} Unit Siap
                              </span>
                            )}
                          </td>

                          {/* Kolom Kapasitas Angkut */}
                          <td>
                            {kapasitasTersedia > 0 ? (
                              <div>
                                <span className="fw-bold text-success font-monospace d-block">
                                  {kapasitasTersedia.toLocaleString("id-ID")} Kg
                                </span>
                                <small className="text-muted" style={{ fontSize: "11px" }}>
                                  dari total {kapasitasTotal.toLocaleString("id-ID")} Kg
                                </small>
                              </div>
                            ) : (
                              <span className="badge bg-light text-muted border px-2 py-1" style={{ fontSize: "11px" }}>
                                Kapasitas Penuh
                              </span>
                            )}
                          </td>

                          {/* Kolom Aksi */}
                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-2">
                              {/* Tombol Detail Baru */}
                              <button
                                className="btn btn-outline-info btn-sm rounded-pill px-3 fw-bold shadow-sm"
                                onClick={() => navigate(`/kebunld/${item.logistik_id}`)}
                              >
                                <i className="fa fa-info-circle me-1"></i> Detail
                              </button>
                              
                              {/* Tombol Pilih */}
                              <button
                                className={`btn btn-sm rounded-pill px-3 fw-semibold ${
                                  isReady
                                    ? "btn-outline-primary"
                                    : "btn-light text-muted border disabled"
                                }`}
                                disabled={!isReady}
                                onClick={() => handlePilih(item.logistik_id)}
                              >
                                {isReady ? "Pilih" : "Penuh"}
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <span className="fs-1 d-block mb-2">🚚</span>
                <h6 className="fw-semibold">Belum Ada Data Logistik</h6>
                <p className="mb-0 small">Tidak ada vendor logistik yang terdaftar atau tersedia saat ini.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal Input Rencana Panen */}
      {showModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow rounded-4 overflow-hidden">
              <div className="modal-header bg-light border-bottom px-4 py-3">
                <h5 className="modal-title fw-bold text-dark mb-0">Pilih Vendor Logistik</h5>
                <button
                  type="button"
                  className="btn-close shadow-none"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body px-4 py-4">
                {error && (
                  <div className="alert alert-danger rounded-3 py-2 px-3 mb-3 small fw-medium">
                    ⚠️ {error}
                  </div>
                )}

                <div className="form-group">
                  <label className="fw-semibold text-secondary small mb-2">ID Rencana Panen</label>
                  <input
                    type="text"
                    className="form-control rounded-3"
                    placeholder="Masukkan ID Rencana Panen..."
                    value={rencanaPanenId}
                    onChange={(e) => setRencanaPanenId(e.target.value)}
                    autoFocus
                  />
                  <small className="text-muted mt-2 d-block" style={{ fontSize: "12px" }}>
                    Masukkan ID Rencana Panen yang akan ditugaskan ke armada logistik terpilih.
                  </small>
                </div>
              </div>
              <div className="modal-footer border-top px-4 py-3">
                <button
                  type="button"
                  className="btn btn-light rounded-pill px-4 fw-medium text-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Batal
                </button>
                <button
                  type="button"
                  className="btn btn-success rounded-pill px-4 fw-bold shadow-sm"
                  onClick={handleSubmitRencanaPanen}
                >
                  Konfirmasi Pengiriman
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KebunL;